// ##### Komarov 2025-07-23
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../hooks/useLocalizedText';

// ##### Komarov 2025-07-14
const ClickableLayer_02_ToursAutocompleteSmallScreenDivTag = ({
  width,
  height,
  onRangePickerDivClick,
  tourDate
}) => {
  // ##### Komarov 2025-08-05
  const ChooseMonth = useLocalizedText('ChooseMonth');

  return (
    <div
      data-component="ClickableLayer_02_ToursAutocompleteSmallScreenDivTag"
      style={{
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-around',
        width: width,
        backgroundColor: 'white',
        border: '#196fbb',
        borderStyle: 'solid',
        borderRadius: '1rem',
        height: height,
        fontFamily: 'Arial',
        alignItems: 'center',
        // ##### 23-04-26 Komarov
        margin: '0.3vw',
      }}
      id="clickableLayer_02_ToursAutocompleteSmallScreen"
      onClick={e => onRangePickerDivClick(e)}
      // ##### 24-03-21 Komarov
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          onRangePickerDivClick(e);
        }
      }}
    >
      {/* ##### 23-03-30 Komarov */}
      <div
        style={{
          display: 'inline-flex',
          flexDirection: 'row',
          marginTop: '0.25em',
        }}
      >
        {tourDate === '' ? ChooseMonth : tourDate}
      </div>
    </div>
  );
};

export default ClickableLayer_02_ToursAutocompleteSmallScreenDivTag;
